import React, { useState } from "react";
import Styles from "./ForgetPassword.module.css";
import PersonIcon from "@mui/icons-material/Person";
import { sendOtpForPasswordUpdate } from "../../../Services/ApiCalling/Auth";
import ForgetPasswordOtp from "./ForgetPasswordOtp";
import ResetPassword from "./ResetPassword";
import { toast } from "react-toastify";
import { decryptData } from "../../../commons/Decode";

const ForgetPassword = () => {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState("username"); // username, otp, reset-password
  const [verifiedOtp, setVerifiedOtp] = useState("");

  const handleUsernameChange = (value) => {
    setUsername(value);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateUsername = (username) => {
    const usernameRegex = /^[a-zA-Z0-9_]{3,}$/;
    return usernameRegex.test(username);
  };

  const handleContinue = async () => {
    const trimmedUsername = username.trim();

    if (!trimmedUsername) {
      toast.error("Please enter a username or email address");
      return;
    }

    const isValidEmail = validateEmail(trimmedUsername);
    const isValidUsername = validateUsername(trimmedUsername);

    if (!isValidEmail && !isValidUsername) {
      toast.error("Please enter a valid username or email address");
      return;
    }

    setLoading(true);
    try {
      const response = await sendOtpForPasswordUpdate(trimmedUsername);

      let data = null;
      if (response?.data) {
        data = await decryptData(response.data);
      }
      if (data?.code === 200 || data?.success === true) {
        if (data?.message) {
          toast.success(data.message);
        } else {
          toast.success("OTP sent successfully to your registered email");
        }
        setCurrentStep("otp");
      } else {
        const errorMessage =
          data?.error ||
          data?.message ||
          "Failed to send OTP. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      let errorMessage = "Failed to send OTP. Please try again.";
      let errorData = null;

      if (error?.response?.data) {
        errorData = await decryptData(error.response.data);
      } else if (error?.data) {
        errorData = await decryptData(error.data);
      }

      if (errorData?.error) {
        errorMessage = errorData.error;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleOtpVerified = (otp) => {
    setVerifiedOtp(otp);
    setCurrentStep("reset-password");
  };

  const handleBackToUsername = () => {
    setCurrentStep("username");
    setVerifiedOtp("");
  };

  const handlePasswordReset = () => {
    // Redirect to login page after successful password reset
    toast.success("Password reset completed. Redirecting to login...");
    setTimeout(() => {
      window.location.href = "/login";
    }, 2000);
  };

  // Render different screens based on current step
  if (currentStep === "otp") {
    return (
      <ForgetPasswordOtp
        username={username}
        onOtpVerified={handleOtpVerified}
        onBackToUsername={handleBackToUsername}
      />
    );
  }

  if (currentStep === "reset-password") {
    return (
      <ResetPassword
        username={username}
        otp={verifiedOtp}
        onPasswordReset={handlePasswordReset}
      />
    );
  }

  // Default username input screen
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleContinue();
    }
  };
  return (
    <>
      <div className={Styles.loginContainer}>
        <div className={Styles.loginDisplayContainer}>
          <div className={Styles.loginMainCont}>
            <div className={Styles.loginCompDisplayNameCont}>
              <div className={Styles.compNameText}>GNA Energy</div>
              <div className={Styles.platformText}>Reset Password</div>
            </div>
            <div className={Styles.loginHeadingCont}>
              <div className={Styles.loginHeadingText}></div>
              <div>
                Enter your username or email address and we'll send an OTP to
                your registered email address.
              </div>
            </div>
            <div className={Styles.inputMainCOnt}>
              <div className={Styles.loginInputCont}>
                <div className={Styles.loginInputElemCOnt}>Username/Email</div>
                <div className={Styles.inputFieldCont}>
                  <PersonIcon style={{ fontSize: "16px" }} />
                  <div className={Styles.inputField}>
                    <input
                      type="text"
                      placeholder="Enter username or email"
                      value={username}
                      onChange={(e) => handleUsernameChange(e.target.value)}
                      onKeyPress={handleKeyPress}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
              <div className={Styles.loginInputCont} style={{ height: "60px" }}>
                <div className={Styles.loginInputElemCOnt}></div>
                <div>
                  {/* <LockIcon style={{ fontSize: "16px" }} /> */}
                  <div>
                    {/* <input
                      type={showPassword ? "text" : "password"}
                      name=""
                      id=""
                     
                      value={password}
                      onChange={(e) => handlePasswordChange(e.target.value)}
                    /> */}
                  </div>
                  {/* {showPassword ? (
                    <span onClick={() => setShowPassword(false)}>
                      <VisibilityIcon style={{ fontSize: "16px" }} />
                    </span>
                  ) : (
                    <span onClick={() => setShowPassword(true)}>
                      <VisibilityOffIcon style={{ fontSize: "16px" }} />
                    </span>
                  )} */}
                </div>
              </div>
            </div>
            <button
              type="button"
              disabled={loading || !username.trim()}
              className={Styles.signinButton}
              onClick={handleContinue}
            >
              {loading ? "Sending OTP..." : "Continue"}
            </button>
            <button
              type="button"
              disabled={loading}
              className={Styles.backBtn}
              onClick={() => (window.location = "/login")}
            >
              Cancel
            </button>

            {/* <div className={Styles.regReqContainer}>
              <span>Don’t Have An Account?</span>
              <span className={Styles.regButton}>Register</span>
            </div> */}
          </div>
          <div className={Styles.bottomText}>
            © {new Date().getFullYear()}, <b>GNA Energy</b> Private Limited All
            Rights Reserved
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
